import React from 'react';
import { motion } from 'framer-motion';
import { samplePages } from '../data/content';
import { CTAButton } from './CTAButton';
export function MaterialPreview() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-157" data-mp="27yfn2lpdc23l">
      <div className="mx-auto max-w-5xl" data-id="element-158" data-mp="27xxhgygtgbj0">
        <div className="mx-auto max-w-2xl text-center" data-id="element-159" data-mp="2cxigt9zwelw9">
          <h2 className="font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-160" data-mp="2cvz23ntw4iwl">
            Zobacz, jak wyglądają materiały przed zakupem.
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-161" data-mp="22zm80oufo31b">
            Przejrzyste strony teorii, ćwiczenia dla uczniów, sprawdziany i materiały do
            wykorzystania na lekcji.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-3" data-id="element-162" data-mp="1tacfj7vogico">
          {samplePages.map((page, i) => <motion.figure key={page.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col overflow-hidden rounded-2xl border border-chem/20 bg-white shadow-sm shadow-chem/5" data-id="element-163" data-mp="1faa0ruio251n" data-mpi={i}>
              <img src={page.src} alt={page.alt} loading="lazy" className="block aspect-[4/3] w-full object-cover" data-id="element-164" data-mp="2q60699hr5wji" />
              <figcaption className="mt-auto px-4 py-3 text-sm font-semibold text-chem-deep" data-id="element-165" data-mp="1xhcfiye8ieyk">
                {page.caption}
              </figcaption>
            </motion.figure>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-166" data-mp="27bcq3fsacceo">
          <CTAButton label="Chcę cały pakiet Wizualna Chemia™" microcopy="Dostęp cyfrowy otrzymasz zaraz po zakupie." data-id="element-167" data-mp="22hqnkgfu5owl" />
        </div>
      </div>
    </section>;
}